export default function (date) {
  const n = date ? new Date(date) : new Date();
  // let month;

  return `${n.getFullYear()}-${(n.getMonth() + 1)
    .toString()
    .padStart(2, "0")}-${n.getDate().toString().padStart(2, "0")}`;
}
